/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { SankeyFlow } from 'common/widgets/sankey-chart/models/sankey-flow';
import { SankeyChartEl } from 'common/widgets/sankey-chart';
import { InsightsQueryResults, InsightsSeriesTree, ShowClause } from 'common/report/insights/util/types';
import { InsightsBookmarkParams } from 'common/types/reports/bookmark';
import { FlowsQueryEventEntry } from 'common/query-builder/query-entry-section/types';
import { getBehaviorShowClauses } from 'common/report/insights/models/utils';
import { getEntries } from 'common/report/insights/util/events';
import css from './index.inline.styl';
type InsightsTopPathsParams = {
  insightsResponse: InsightsQueryResults;
  bookmark: InsightsBookmarkParams;
  disableClickNode?: boolean;
};
export interface InsightsTopPathsJsxProps {
  params: InsightsTopPathsParams;
}
export class InsightsTopPathsChart extends ParamComponent<InsightsTopPathsParams> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => this.renderTemplate(),
      params: {
        insightsResponse: Object,
        bookmark: Object,
        disableClickNode: Boolean
      }
    };
  }
  private getSankeyChartAttrs() {
    return {
      alignbreakdowns: true,
      alwaysbreakdown: false,
      reverse: false,
      'tooltip-enabled': true,
      'disable-add-step': true,
      'disable-anchor-event-labels': true,
      'disable-click-node': this.params.disableClickNode
    };
  }
  private getSankeyData(): InsightsSeriesTree<number> {
    const data = this.params.insightsResponse.series;
    const dateKey = Object.keys(data)[0];
    return data[dateKey] as InsightsSeriesTree<number>;
  }
  private getSankeyChartProps() {
    return {
      data: new SankeyFlow(this.getSankeyData(),
      // TODO the below typing is a bit of a lie, these arent necessarily _Flows_ entries
      // since multimetric does not have the concept of that atm, it should be a FunnelEntry but typing is similar
      getEntries({
        showClauses: getBehaviorShowClauses(this.params.bookmark.sections.show as ShowClause[])
      }) as FlowsQueryEventEntry[])
    };
  }
  private renderTemplate() {
    if (!this.params.bookmark) {
      return <div sel='.root' />;
    }
    return <div sel='.root'>
        <SankeyChartEl attrs={this.getSankeyChartAttrs()} props={this.getSankeyChartProps()} />
      </div>;
  }
}
export const InsightsTopPathsChartEl = defineAndMakeJsxFactory<InsightsTopPathsJsxProps>("mp-insights-top-paths-chart", InsightsTopPathsChart);
export const InsightsTopPathsChartReact = panel2react<InsightsTopPathsJsxProps>("mp-insights-top-paths-chart", InsightsTopPathsChart);